import React from 'react';
import { months } from 'AppData';
import RestProvider from 'providers/RestProvider';
import useData from './PrecargasData';
import { localStorageName } from 'providers/localStorageData';
import { loadState } from './../../../providers/localStorage';
import { getUrl } from './../../../config/Config';

const usePrecargas = () => {
    const { properties, valoresPrecarga } = useData();
    const { crudOperation, crudOperationsType } = RestProvider();
    //Obtención del token
    let token = loadState(localStorageName.token, false);
    const parametrosPrecarga = [];

    /** IMPORTANTE: La función evalúa los nombre de la API de los componentes que se hayan insertado en ela rray parametrosPrecarga
     * @function comprobarExistencia Función que comprueba si los componentes a precargar existen en el formulario actual
     * @param {*} form Formulario actual
     * @returns Devuelve un array con el nombre de los componentes existentes.
     */
    const comprobarExistencia = (form) => {
        let parametrosExistentes = [];
        let paginasForm = form['data']['components'];

        for (const parametro of parametrosPrecarga) {
            for (const pagina of paginasForm) {
                let componentesPagina = pagina['components'];
                for (const componente of componentesPagina) {
                    if (parametro === componente['key']) {
                        parametrosExistentes.push(parametro);

                    }
                    if(componente['components'] != null){
                        
                        for(const comp of componente['components']){
                            
                            if(parametro === comp['key']){
                                parametrosExistentes.push(parametro);
                            }
                        }
                    }
                }
            }
        }
        return parametrosExistentes;
    }

    /**
     * @function obtenerValores Función auxiliar utilizada para obtener los valores de un procedimiento
     * @param {*} input Parámetros necesarios para realizar la llamada
     * @returns Valores obtenidos
     */
    const obtenerValores = async (input) => {
        let respuesta = null;
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ADMINISTRADOR, { url: properties.URL_VALORES_FORM, method: 'post', data: input }).then(response => {
            respuesta = response.data;
        });
        return respuesta;
    }

    /**
     * @function obtenerUrlEndPoint Obtiene la url del endPoint
     * @param {*} resource Recurso del MS
     * @param {*} ms Nombre del MS con el que aparece en mappedService
     * @param {*} urlEndPoint Url del endPoint
     * @param {*} param Parámetros que reciba el endpoint
     * @returns La url del endPoint al completo
     */
    const obtenerUrlEndPoint = (resource, ms, urlEndPoint, param) => {
        let url = null, host = getUrl();

        //Se prevee que puedan aparecer como undefined, si es así no se insertarán
        let parametro = param === undefined ? '' : `${param}`;
        let urlEP = urlEndPoint === undefined ? '' : `${urlEndPoint}`;

        url = `${host}${ms}/${resource}${urlEP}${parametro}`;
        
        return url;
        
    }

    /**
     * @function obtenerDestinatariosExpedientes obtiene los valores para realizar la precarga de los destinatarios de los expedientes referentes a un procedimiento
     * @param {*} id del procedimiento
     * @returns el objeto que con los valores obtenidos
     */
    const obtenerDestinatariosExpedientes = async (id, form) => {
        let valores = {}, destinatario = null, tipoDestinatario = null, urlEndPoint = null;
        let input = {
            idProcedimiento: id,
            valoresAbuscar: [valoresPrecarga.destinatario.apiName]
        };
        //Paso 1. Se obtiene el tipo de destinatario y se inserta en el array de parametrosPrecarga
        destinatario = await obtenerValores(input);
        tipoDestinatario = destinatario[valoresPrecarga.destinatario.apiName];
        parametrosPrecarga.push(tipoDestinatario);

        //Paso 2. Se evalúa si el componente a precargar existe en el formulario
        if (comprobarExistencia(form).includes(tipoDestinatario)) {

            /* Paso 3. Se evalúa de que tipo de destinatario es el componente a precargar (centralizada o provincializada) y se genera el objeto
            para la usePrecargas. */
            if (tipoDestinatario === valoresPrecarga.destinatario.centralizada.apiName) {
                input.valoresAbuscar = [destinatario[valoresPrecarga.destinatario.apiName]];
                valores = await obtenerValores(input);
            }
        }
        return valores;
    }

    /**
     * @function obtenerInformacionBoja obtiene los valores para realizar la precarga de la información BOJA referente a un procedimiento
     * @param {*} id del procedimiento
     * @returns el objeto que con los valores obtenidos
     */
    const obtenerInformacionBoja = async (id, form) => {
        let valores = {};
        //Paso 1. Se inserta el nombre de la API del componente a precargar en el array parametrosPrecarga
        parametrosPrecarga.push(valoresPrecarga.informacionBoja.apiName);

        //Paso 2. Se comprueba si el componente existe en el formulario
        if (comprobarExistencia(form).includes(valoresPrecarga.informacionBoja.apiName)) {
            let valoresObtenidos = null, fecha = null;
            let input = {
                idProcedimiento: id,
                valoresAbuscar: valoresPrecarga.informacionBoja.valoresAbuscar
            };

            //Paso 3. Se genera el objeto para la precarga
            valoresObtenidos = await obtenerValores(input);
            fecha = new Date(valoresObtenidos[valoresPrecarga.informacionBoja.valoresAbuscar[1]]);
            valores = {
                informacionBoja: {
                    ...valoresObtenidos,
                    diaOrdenDecretoLey: fecha.getDate(),
                    mesOrdenDecretoLey: `${months[fecha.getMonth()]}`,
                    anyoOrdenDecretoLey: `${fecha.getFullYear()}`,
                    anyoConvocatoriaEjercicio: valoresObtenidos[valoresPrecarga.informacionBoja.valoresAbuscar[4]]
                }
            };
        }
        return valores;
    }
    

    /*######################################## PRECARGA PARA FORMULARIOS DE NUEVA SOLICITUD ########################################*/

    const obtenerProvincias = async(id, form) => {
        let valores={};
        parametrosPrecarga.push(valoresPrecarga.direccion.provincia.apiName);
        
        let tipoDestinatario =valoresPrecarga.direccion.provincia.apiName;
        
        if (comprobarExistencia(form).includes(tipoDestinatario)) {
            //parametrosPrecarga.push(valoresPrecarga.destinatario.provincia.provincias.apiName);
            //if(comprobarExistencia(form).includes(valoresPrecarga.destinatario.provincia.provincias.apiName)){
               let  urlEndPoint= obtenerUrlEndPoint(properties.RESOURCE_MANAGER, properties.MS_TREWA, properties.URL_PROVINCIAS);
               token = loadState(localStorageName.token, false);

               valores = {
                    provincia: {
                        token: `Bearer ${token}`,
                        url: urlEndPoint
                    }
                    
                }
                
            //}
            }
            return valores;
    }
    
    return { obtenerInformacionBoja, obtenerDestinatariosExpedientes, obtenerUrlEndPoint, obtenerProvincias };
}
export default usePrecargas;
